<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2.8" width="12" height="14.4" rx="2.2"/><path d="M2.5 6.5h2M2.5 10h2M2.5 13.5h2"/><circle cx="10" cy="8.4" r="1.9"/><path d="M7.2 14c.6-1.5 1.6-2.2 2.8-2.2s2.2.7 2.8 2.2"/></svg>
</template>
